// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2AibE","inner":"Footer_inner__1_7kB","nextIcon":"Footer_nextIcon__3tCJJ","innerLeft":"Footer_innerLeft__7GN0e"};